export default __webpack_public_path__ + "static/Graphik-Regular-Web-d71bcf2d38f82d3f8f36e08857d660d0.woff";